import React from 'react';

import { BeraReportV2Provider } from '@/context/BeraReportV2';

import { Content } from './Content';

import type { FileForCustomReport } from '@/components/ui/Inputs/types/response/file';
import type { BeraJobSummary } from '@/types/Bera';

interface BeraReportV2Props {
	file: FileForCustomReport;
	jobSummary: BeraJobSummary;
	autoOpenResult?: boolean;
	onPrevious: () => void;
	onAutoOpenResult?: () => void;
}

export function BeraReportV2(props: Readonly<BeraReportV2Props>): JSX.Element {
	const { file, jobSummary, autoOpenResult = false, onPrevious, onAutoOpenResult } = props;

	return (
		<BeraReportV2Provider file={file} jobSummary={jobSummary}>
			<Content autoOpenResult={autoOpenResult} onPrevious={onPrevious} onAutoOpenResult={onAutoOpenResult} />
		</BeraReportV2Provider>
	);
}
